// extracted by mini-css-extract-plugin
export default {"tenantBanner":"TenantInfoBanner_tenantBanner__5Nr97","value":"TenantInfoBanner_value__5mFm3"};